import React, { useEffect, useState } from "react";
import { server } from "../server";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import pulse from "../assets/Pulse.gif";
export default function UserRoles() {
  const verifyToken = JSON.parse(localStorage.getItem("bkbtoken"));
  const [allUsers, setAllUsers] = useState([]);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [registerModal, setRegisterModal] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const Register = (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userName: email.toLowerCase(),
        firstName: firstName,
        lastName: lastName,
        mobile: mobile,
        password: password,
        userType: "string",
        designation: "string",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(`${server}/auth/Register`, requestOptions)
        .then((response) => response.text())
        .then((result) => setErrorMsg(JSON.parse(result)))
        .catch((error) => console.error(error));

      // setEmail("");
      // setPassword("");
      // setFirstName("");
      // setLastName("");
      // setMobile("");
      setTimeout(() => {
        setLoading(false);
        // setErrorMsg("");
  
      }, 1000);
    } catch (e) {
    } finally {
      setTimeout(() => {
        setLoading(false);
        
      }, 1000);
    }
  };

  const getUsers = async () => {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${verifyToken}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${server}/auth/getAllUsers`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setAllUsers(JSON.parse(result));
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getUsers();
  }, []);

  const closeModal = () => {
    setRegisterModal(true);
    setActionModal(!actionModal);
  };

  return (
    <div className="relative">
      <div>
        <div className="flex gap-4 items-center">
          <input
            type="search"
            className="p-2 border-[0.7px] border-slate-800 rounded-md outline-none w-[300px]"
            placeholder="Search users..."
          />
          <div className="relative flex justify-center items-center gap-2 border-[0.7px] border-slate-800 p-2 text-black rounded-md">
            <button className="" onClick={() => setActionModal(!actionModal)}>
              Actions
            </button>
            <IoIosArrowDropdownCircle
              className={`${
                actionModal ? "rotate-0" : "rotate-180"
              } duration-150`}
            />
            {actionModal && (
              <div className="absolute ml-12 mt-36 bg-white w-[150px] shadow-sm shadow-gray-600 duration-150 rounded-md border-[0.4px]">
                <div className="">
                  <ul className="">
                    <li className="border-b-[0.1px] p-1 hover:bg-blue-950 cursor-pointer hover:text-white duration-150">
                      <button className="w-full text-left" onClick={closeModal}>
                        Add User
                      </button>
                    </li>
                    <li className="border-b-[0.1px] p-1 hover:bg-blue-950 cursor-pointer hover:text-white duration-150">
                      Action 2
                    </li>
                    <li className=" p-1 hover:bg-blue-950 cursor-pointer hover:text-white duration-150">
                      Action 3
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-5">
        <table className="w-full">
          <thead>
            <tr className="text-left bg-gray-100">
              <th className="p-2">Sl no.</th>
              <th className="p-2">First name</th>
              <th className="p-2">Last name</th>
              <th className="p-2">Role</th>
              <th className="p-2">E-mail</th>
              <th className="p-1">Created on</th>
              <th className="p-2"></th>
            </tr>
          </thead>
          <tbody>
            {allUsers?.map((item, index) => (
              <tr
                onClick={() =>
                  navigate("../editUser", {
                    state: {
                      id: item.userName,
                    },
                  })
                }
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-white" : "bg-white"
                } border-b-[0.1px] hover:bg-gray-50 hover:cursor-pointer`}
              >
                <td className="p-2">{++index}</td>
                <td className="p-2">{item.firstName}</td>
                <td className="p-2">{item.lastName}</td>
                <td className="p-2">{item.userType}</td>
                <td className="p-2">{item.userName}</td>

                <td className="p-2">
                  {new Date(item.createdAt).toLocaleString("en-In")}
                </td>

                <td className="p-2">
                  <div className="text-right">
                    <MdOutlineKeyboardArrowRight className="text-black text-lg" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {registerModal && (
        <div className="fixed flex justify-end items-center inset-0 bg-gray-500 z-40 bg-opacity-75">
          <div className="bg-white h-full w-[600px] animate-slide-from-right border-white relative">
            <form onSubmit={Register}>
              <div className="flex justify-between p-4 shadow-md">
                <div className="text-cyan-700 font-semibold">Add New User</div>
                <div>
                  <button onClick={() => setRegisterModal(false)}>X</button>
                </div>
              </div>
              <div className="bg-gray-200 h-screen flex flex-col p-4">
                <label className="ml-4 mt-2">Email</label>
                <input
                  className="p-2 bg-white mb-2 mx-2 rounded-sm"
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label className="ml-4">Password</label>
                <input
                  className="p-2 bg-white mb-2 mx-2 rounded-sm"
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />

                {password.length < 8 && (
                  <div className="text-red-500 mb-2 ml-4 text-sm">
                    Password should contain atleast 8 characters.
                  </div>
                )}
                <label className="ml-4">First name</label>
                <input
                  className="p-2 bg-white mb-2 mx-2 rounded-sm"
                  placeholder="Enter first name"
                  value={firstName}
                  required
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <label className="ml-4">Last name</label>
                <input
                  className="p-2 bg-white mb-2 mx-2 rounded-sm"
                  placeholder="Enter last name"
                  value={lastName}
                  required
                  onChange={(e) => setLastName(e.target.value)}
                />
                <label className="ml-4">Mobile no.</label>
                <input
                  className="p-2 bg-white mb-2 mx-2 rounded-sm"
                  placeholder="Enter mobile no"
                  value={mobile}
                  maxLength={10}
                  onChange={(e) => setMobile(e.target.value)}
                />

                <div className="text-center my-4 text-red-600">
                  {errorMsg?.Email
                    ? errorMsg?.Email[0]
                    : errorMsg?.Password
                    ? errorMsg?.Password[0]
                    : ""}
                </div>

                {errorMsg?.user&&<div className="text-center my-4 text-green-700">
                  
                  Registered Successfully
                  </div>}
              </div>
              <div className="absolute bottom-0 bg-white shadow-sm shadow-gray-600 w-full p-3 flex justify-end">
                <button
                  disabled={loading}
                  className="bg-cyan-700 w-48 text-white shadow-sm shadow-gray-400 p-2 rounded-md"
                  type="submit"
                >
                  {loading ? (
                    <img src={pulse} className="w-8 h-8 mx-auto" alt="wait" />
                  ) : (
                    "Create New User"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
